// extracted by mini-css-extract-plugin
export default {"body":"TextReveal_body__aQElA","phrase":"TextReveal_phrase__tlTsk","mask":"TextReveal_mask__CyIGQ","sub":"TextReveal_sub__qwhMk"};